export const ImageUtils = {

  obterUrlCompletaImagem: (caminhoRelativo, pasta = null) => {
    if (caminhoRelativo) {
      if (caminhoRelativo.startsWith('http') || caminhoRelativo.startsWith('https')) {
        return caminhoRelativo
      }
      if (pasta && !caminhoRelativo.includes('/')) {
        return process.env.VUE_APP_BASE_FILES_URL + pasta + caminhoRelativo + `?v=${process.env.PACKAGE_VERSION}`
      }
      return process.env.VUE_APP_BASE_FILES_URL + caminhoRelativo + `?v=${process.env.PACKAGE_VERSION}`
    }
  }

}

export default ImageUtils
